const translateAnomaliesFr = {
  anomalies: {
    show: {
      title: "Afficher les anomalies",
    },
  },
};

export default translateAnomaliesFr;
